import { render, staticRenderFns } from "./PermissionCreateModal.vue?vue&type=template&id=7cdd817a&scoped=true"
import script from "./PermissionCreateModal.vue?vue&type=script&lang=js"
export * from "./PermissionCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdd817a",
  null
  
)

export default component.exports